import {FC, ReactNode} from 'react';
import {Box, Typography} from '@mui/material';

export interface DetailsRow {
  label: string;
  value: ReactNode;
}

interface Props {
  rows: DetailsRow[];
}

const EMPTY_VALUE = '—';

const isEmptyValue = (value: ReactNode) =>
  value === null || value === undefined || value === '';

export const DetailsList: FC<Props> = ({rows}) => (
  <Box
    display="grid"
    gridTemplateColumns="220px 1fr"
    gap={1}
    alignItems="center"
  >
    {rows.map(({label, value}) => (
      <Box key={label} display="contents">
        <Typography color="text.secondary">{label}</Typography>
        <Box sx={{overflowWrap: 'anywhere'}}>
          {isEmptyValue(value) ? EMPTY_VALUE : value}
        </Box>
      </Box>
    ))}
  </Box>
);
